<template>
  <div class="new-login-container">
    <div class="logo-img"></div>
    <div class="login-main">
      <el-row style="height: 100%;">
        <el-col :span="12" class="login-main-left">
          <app-account-login></app-account-login>
        </el-col>
        <el-col :span="12" class="login-main-right">
          <div class="login-main-img">
            <img src="../../../assets/images/login/loginMain.png" alt="">
          </div>
          <div class="login-main-topic">想要更全面、精益、智能的积加ERP</div>
          <div class="login-main-text">（点击下方按钮）</div>
          <el-button class="login-main-btn" @click="goLinkErpX">积加ERP-X版</el-button>
          <div class="login-main-text">积加ERP-X：适用于中大型卖家</div>
          <div class="login-main-text">积加M版：适用于中小型卖家</div>
        </el-col>
      </el-row>
    </div>
    <footer class="login-fotter"> Copyright©️ 2022 深圳市积加跨境网络科技有限公司. All rights reserved. 粤ICP备2021055125号 </footer>
  </div>
</template>

<script>
  import AppAccountLogin from '../login/components/account-login'
  export default {
    name: "AppNewLogin",
    components: {AppAccountLogin},
    data: function () {
      return {
        loginModel: 'account' || 'phone',
        redirect: undefined,
        otherQuery: {}
      }
    },
    methods: {
      goLinkErpX() {
        window.open(`https://www.gcbnt.com/ProductsSt_ymkj.html`);
      }
    }
  }
</script>

<style lang="scss" scoped>
.new-login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("~@/assets/images/login/loginBg.png");
  background-size: 100%;
  .logo-img {
    width: 135px;
    height: 16px;
    position: absolute;
    top: 68px;
    left: 85px;
    background-image: url("~@/assets/images/login/logo.png");
    background-size: 100%;
  }
  .login-main {
    width: 800px;
    height: 500px;
    background: #FFFFFF;
    box-shadow: 0px 12px 20px rgba(66, 84, 118, 0.16);
    border-radius: 4px;
    .login-main-left {
      height: 100%;
      display: flex;
      justify-content: center;
    }
    .login-main-right {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-image: url("~@/assets/images/login/loginBg2.png");
      background-color: #0045f0;
      background-size: 100%;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      .login-main-img {
        width: 220px;
        margin-top: 60px;
      }
      .login-main-topic {
        font-weight: 600;
        font-size: 18px;
        background: linear-gradient(90deg, #BEDAFF 0%, #E8F3FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
        margin-top: 35px;
      }
      .login-main-text {
        font-size: 12px;
        color: #BEDAFF;
        margin-top: 8px;
      }
      .login-main-btn {
        width: 280px;
        height: 40px;
        margin-top: 36px;
        margin-bottom: 8px;
        color: #0045F0;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
  .login-fotter {
    position: fixed;
    bottom: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #C9CDD4;
  }
}
@media (max-width: 864px) {
  .new-login-container {
    background: none;
    .logo-img {
      display: none;
    }
    .login-main {
      width: 100%;
      height: 100%;
      background: #FFFFFF;
      box-shadow: none;
      border-radius: 0;
      .login-main-left {
        width: 100%;
      }
      .login-main-right {
        display: none;
      }
    }
    .login-fotter {
      display: none;
    }
  }
}
</style>
